<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options" @submit:create:success="submitCallback"
    @submit:update:success="submitCallback" @fetchOptions="fetchOptions" @resetOptions="resetOptions"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";
import isOrderableBusiness from "@/components/Business/orderable";

export default {
  name: "TransferForm",
  components: {
    AdminForm,
  },
  props: ["id_to_edit", "params"],
  data() {
    return {
      config: config,
      form: {
        agency_number: null,
        old_business_number: null,
        new_agency_number: null,
        new_business_number: null,
        employee_number: null,
        axiloc_creation_date: this.$moment().format("YYYY-MM-DD"),
        unique_references: [{ id: null }],
      },
      isBusy: false,
    };
  },
  computed: {
    options: function () {
      let user = this.$store.getters["user/getItem"](this.form.user_id)
      let agencies = user ? this.$store.getters["agency/getAllByUser"](user).selectOptions(
          "internal_number",
          ["internal_number", " - ", "name"]
        ) : []
      return {
        user_id_options: _.orderBy(
          this.$store.getters["user/getByStatusSlug"]("user-active").selectOptions("id", [
            "firstname",
            " ",
            "lastname",
            " (",
            "employee.number",
            ")",
          ]),
          "text"
        ),
        agency_number_options: agencies,
        new_agency_number_options: agencies,
        id_options: this.$store.getters["reference/getAll"].selectOptions("id", [
          "product.name",
          " - ",
          "internal_code",
        ]),
        old_business_number_options: this.$store.getters["business/getByAgencyNumber"](
          this.form.agency_number
        ).selectOptions("number", ["number", " - ", "name"]),
        new_business_number_options: this.$store.getters["business/getByAgencyNumber"](
          this.form.new_agency_number
        )
          .filter(isOrderableBusiness)
          .selectOptions("number", ["number", " - ", "name"]),
        employee_number_options: this.$store.getters["user/getByAgencyNumberAndStatusSlug"]({
          agency: this.form.new_agency_number,
          status: "user-active",
        }).selectOptions("employee.number", [
          "firstname",
          " ",
          "lastname",
          " (",
          "employee.number",
          ")",
        ]),
      };
    },
  },
  watch: {
    "form.user_id": function (user_id) {
      let user = this.$store.getters["user/getItem"](user_id)
      let agencies = this.$store.getters["agency/getAllByUser"](user).selectOptions(
          "internal_number",
          ["internal_number", " - ", "name"]
        )
      this.options.agency_number_options     = agencies
      this.options.new_agency_number_options = agencies
    },
    "form.agency_number": function (agency) {
      this.$store
        .dispatch("business/getAllForSelectByAgencyNumber", {
          wait: true,
          agency: agency, add: true
        })
        .then(() => {
          this.options.old_business_number_options = this.$store.getters[
            "business/getByAgencyNumber"
          ](agency).selectOptions("number", ["number", " - ", "name"]);
        });
    },
    "form.old_business_number": function (business) {
      this.$store.dispatch("reference/getAllByBusinessNumber", {
        wait: true,
        business: business,
      });
    },
    "form.new_agency_number": function (agency) {
      this.$store
        .dispatch("business/getAllForSelectByAgencyNumber", {
          wait: true,
          agency: agency, add: true
        })
        .then(() => {
          this.options.new_business_number_options = this.$store.getters[
            "business/getByAgencyNumber"
          ](agency)
            .filter(isOrderableBusiness)
            .selectOptions("number", ["number", " - ", "name"]);
        });
      this.options.employee_number_options = this.$store.getters[
        "user/getByAgencyNumberAndStatusSlug"
      ]({ agency: agency, status: "user-active" }).selectOptions("employee.number", [
        "firstname",
        " ",
        "lastname",
        " (",
        "employee.number",
        ")",
      ]);
    },
    params: function (params) {
      this.form = {
        ...{
          agency_number: null,
          old_business_number: null,
          new_business_number: null,
          employee_number: null,
          axiloc_creation_date: this.$moment().format("YYYY-MM-DD"),
          unique_references: [{ id: null }],
        },
        ...params,
      };
    },
  },
  mounted() {
    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true,
        })
        .then(() => {
          let item = _.cloneDeep(this.$store.getters[config.storeNamespace + "/getItem"](id));
          this.form = {
            ...item,
            agency_number: item.agency ? item.agency.internal_number : null,
            old_business_number: item.old_business ? item.old_business.number : null,
            new_agency_number: item.new_agency ? item.new_agency.internal_number : null,
            new_business_number: item.new_business ? item.new_business.number : null,
            employee_number: item.employee ? item.employee.number : null,
            user_id: item.user ? item.user.id : null,
          };

          this.$store.dispatch("business/getAllForSelectByAgencyNumber", {
            agency: item.agency.internal_number,
          });
          this.$store.dispatch("reference/getAllByBusinessNumber", {
            business: item.old_business.number,
          });
          if (item.employee) {
            this.$store.dispatch("user/getItem", {
              id: item.employee.id,
            });
          }
          if (item.user) {
            this.$store.dispatch("user/getItem", {
              id: item.user.id,
              add: true
            });
          }

          this.isBusy = false;
        });
    } else {
      this.form = { ...this.form, ...this.params };
    }
    this.$store.dispatch("agency/getAllForSelect")
  },
  methods: {
    submitCallback(response) {
      this.$emit("submited");
    },
    fetchOptions(field_name, search, loading) {
      if (field_name == 'employee_number' || field_name == 'user_id') {
        this.$store.dispatch("user/getAllForSelectBySearch", { wait: true, search: search, add: true }).then(() => {
          if (this.form.employee_number && !this.options.employee_number_options.find(item => item.value == this.form.employee_number)) {
            this.$store.dispatch("user/getItemByEmployeeNumber", {
              employee_number: this.form.employee_number, add: true
            });
          }
          if (this.form.user_id && !this.options.user_id_options.find(item => item.value == this.form.user_id)) {
            this.$store.dispatch("user/getItem", {
              id: this.form.user_id, add: true
            });
          }
        })
      }
    },
    resetOptions(field_name) {
      if (this.form.employee_number && !this.options.employee_number_options.find(item => item.value == this.form.employee_number)) {
        this.$store.dispatch("user/getItemByEmployeeNumber", {
          employee_number: this.form.employee_number, add: true
        });
      }
      if (this.form.user_id && !this.options.user_id_options.find(item => item.value == this.form.user_id)) {
        this.$store.dispatch("user/getItem", {
          id: this.form.user_id, add: true
        });
      }
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Transfer/TransferForm.vue